export default "__VITE_ASSET__B9c2BFn4__"